/* eslint-disable import/order */
import React from 'react';
import queryString from 'query-string';
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareRoadmapRedirectRoute } from '@jira/router-routes__next-gen-routes/src/softwareRoadmapRedirectRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { Redirect, type Route, type RouteContext } from '@atlassian/react-resource-router';
import { LazyNextGenRoadmap } from './ui/roadmap/index.tsx';

const SoftwareTimelineLegacyRedirect = ({ query }: RouteContext) => {
	const { projectKey, rapidView, ...restQuery } = query;
	return (
		<Redirect
			to={{
				pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
				hash: '',
				search: queryString.stringify(restQuery),
			}}
		/>
	);
};

export const softwareRoadmapRedirectRouteEntry: Route = createEntry(
	softwareRoadmapRedirectRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: SoftwareTimelineLegacyRedirect,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [...getNavigationResources(), ...getIssueViewResources()],
		afterPaint: [LazyIssueApp],
		forPaint: [LazyAtlassianNavigation, LazyNextGenRoadmap],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
